import { getInvoiceStats } from "@/services/invoices.service";
import { useQuery } from "@tanstack/react-query";

export const useInvoiceStats = () => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["invoiceStats"],
    queryFn: getInvoiceStats,
    select: (res) => res?.data,
  });

  return {
    stats: {
      totalInvoices: data?.totalInvoices ?? 0,
      totalSettled: data?.totalSettled ?? 0,
      totalUnsettled: data?.totalUnsettled ?? 0,
      totalValue: data?.totalValue ?? 0,
    },
    isLoading,
    isError,
  };
};
